import React from 'react';

const ChronogramSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      {...props}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 6 h8  m-3 2 h6  m-8 2 h10  m-4 2 h6  m-14 4 h12  m-6 2 h4  M6 20.25 h12 M3.75 6 v12 A2.25 2.25 0 0 0 6 20.25" />
    </svg>
  );
};

export { ChronogramSVG };
